// Underdog (Pluto): three-letter words may be spelled while it is in force
// (play/submit.ts reads the rule), and score more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const underdog: AlignmentDef = {
  id: 'underdog',
  planet: 'pluto',
  name: 'Underdog',
  text: () => `You may spell ${N.underdogLength}-letter words. ${N.underdogLength}-letter words score +${N.underdogPercent}%.`,
  rules: { minWordLength: N.underdogLength },
  wordPercent: (c) => (c.nodes.length === N.underdogLength ? N.underdogPercent : 0),
};
